import { render, staticRenderFns } from "./ConfigureConsultLimit.vue?vue&type=template&id=45e96daf"
import script from "./ConfigureConsultLimit.vue?vue&type=script&lang=js"
export * from "./ConfigureConsultLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports